export const FormSiteCodes = ({ iasEnabled, setIasEnabled, iasIpcCode, setIasIpcCode, bpaEnabled, setBpaEnabled, bpaCode, setBpaCode, pofaEnabled, setPofaEnabled, }) => {
    return (
        <>
            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">IAS Status</p>
                </div>
                <div className=" col-md-6 col-12 custom-control custom-switch">
                    <input className="custom-control-input" type="checkbox" id="site-ias-enabled" checked={ iasEnabled } onChange={ () => setIasEnabled(!iasEnabled) } />
                    <label className="custom-control-label ml-3 custom-toggle" htmlFor="site-ias-enabled"></label>
                    { iasEnabled && <>Active</> }{ !iasEnabled && <>Deactivated</> }
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">IAS/IPC Code</p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="text" value={ iasIpcCode } onChange={ (e) => setIasIpcCode(e.target.value) } />
                    </div>
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">BPA Status</p>
                </div>
                <div className=" col-md-6 col-12 custom-control custom-switch">
                    <input className="custom-control-input" type="checkbox" id="site-bpa-enabled" checked={ bpaEnabled } onChange={ () => setBpaEnabled(!bpaEnabled) } />
                    <label className="custom-control-label ml-3 custom-toggle" htmlFor="site-bpa-enabled"></label>
                    { bpaEnabled && <>Active</> }{ !bpaEnabled && <>Deactivated</> }
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">BPA Site Code</p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="text" value={ bpaCode } onChange={ (e) => setBpaCode(e.target.value) } />
                    </div>
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">POFA Status</p>
                </div>
                <div className=" col-md-6 col-12 custom-control custom-switch">
                    <input className="custom-control-input" type="checkbox" id="site-pofa-enabled" checked={ pofaEnabled } onChange={ () => setPofaEnabled(!pofaEnabled) } />
                    <label className="custom-control-label ml-3 custom-toggle" htmlFor="site-pofa-enabled"></label>
                    { pofaEnabled && <>Active</> }{ !pofaEnabled && <>Deactivated</> }
                </div>
            </div>
        </>
    )
}